// Local vendored build of view-design.
// Expose the same entry resolution behavior as the npm package (import 'view-design').
module.exports = require('./src/index.js');

